module.exports = __webpack_public_path__ + "img/microondas.bd4256d4.svg";